var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.521,
    height: 23.521,
    viewBox: "0 0 23.521 23.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-solid",
    transform: "translate(0.75 0.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M7.079,1.036a1.712,1.712,0,0,0-2.035-1L1.266,1.07A1.722,1.722,0,0,0,0,2.727,19.234,19.234,0,0,0,19.233,21.96a1.722,1.722,0,0,0,1.657-1.266l1.03-3.778a1.712,1.712,0,0,0-1-2.035L16.8,13.163a1.712,1.712,0,0,0-1.988.5l-1.734,2.116a14.509,14.509,0,0,1-6.9-6.9L8.3,7.149a1.713,1.713,0,0,0,.5-1.988L7.079,1.04Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSolid);
export default __webpack_public_path__ + "static/media/phone-solid.19a2bbad6b06188408e917a8b8b3f01f.svg";
export { ForwardRef as ReactComponent };